import { graphql } from '@/generated/gql';

export const DEMAND_DETAIL_MUTATION = graphql(/* GraphQL */ `
  mutation DemandDetailUnifiedUpdate(
    $id: UUID!
    $demandData: TsrctDemandUpdateInput!
    $competitiveBiddingRuleData: TsrctCompetitiveBiddingRuleInput
  ) {
    tesseract {
      demand(id: $id) {
        update(data: $demandData) {
          id
          capabilityIds
          responsibleUserIds
          demandRequest {
            id
            sourceReferences {
              internalId
              sourceReference
              sourceSystem {
                id
                name
              }
              isPrimary
            }
          }
          permissions {
            write
          }
        }
        competitiveBiddingRule {
          update(data: $competitiveBiddingRuleData) {
            id
            variant
            deadline
          }
        }
      }
    }
  }
`);
